import React from "react";
import { Link } from "react-router-dom";

function ProductList({ products, isCategory }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 p-4">
      {products.map((product) => (
        <Link
          key={product.id}
          to={`/product/${product.id}`}
          state={product}
          className="bg-white shadow-md rounded-2xl overflow-hidden hover:shadow-lg transition cursor-pointer"
        >
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-40 object-cover"
          />
          <div className="p-4">
            <h3 className="text-lg font-semibold text-gray-900">{product.name}</h3>
            {product.price && (
              <p className="mt-1 text-indigo-600 font-medium">{product.price} $</p>
            )}
          </div>
        </Link>
      ))}
    </div>
  );
}

export default ProductList;